const PODIUM_MARKETING_HOSTNAME = 'www.podium.com';

const isWindowInIframe = () => window !== window?.parent;

export const isMatchingParentHostname = (hostnameToCompare) => {
  if (!!document?.referrer && !!hostnameToCompare) {
    const { hostname: parentHostname } = new URL(document.referrer);

    return hostnameToCompare === parentHostname;
  } else {
    return false;
  }
};

export const checkIfIsInMarketingIframe = () =>
  isWindowInIframe() && isMatchingParentHostname(PODIUM_MARKETING_HOSTNAME);
